module.exports = __webpack_public_path__ + "media/images/log/log-graph-hokkaido-c708703e0e748a2d761c472ce2e73b4d.svg";